<template>
    <modal
        name="new-editor-modal"
        @before-open="handleBeforeOpen"
        @before-close="isLoaded = false"
        style="z-index: 1001"
    >
        <div
            id="modal-header"
            class="w-100 px-4 py-2 position-relative"
            style="background-color: #1e7bb7"
        >
            <div class="w-100 d-flex">
                <h4 class="text-white">{{ editorTitle }}</h4>
            </div>
            <button
                type="button"
                class="close position-absolute"
                style="right: 1.25rem; top: 30%"
                @click="
                    () => {
                        $modal.hide('new-editor-modal')
                        isLoaded = false
                    }
                "
                aria-label="Close"
            >
                <span aria-hidden="true" class="text-white">&times;</span>
            </button>
        </div>
        <div id="modal-body"
             class="p-4"
             style="overflow-x: auto; height: 85%; position: relative">
            <component
                @closeAfterSave="() => { $modal.hide('new-editor-modal')
                        isLoaded = false }"
                ref="file"
                :handleLoadingStart="handleLoadingStart"
                :handleLoadingEnd="handleLoadingEnd"
                :participantGroup="participantGroup"
                :handleLoaded="handleLoaded"
                :handleLoading="handleLoading"
                :is-editable="isEditable"
                :is="currentFile"
                v-show="action === 'save'"
                :lng="lng"
            ></component>
            <div v-if="action !== 'save'">
                <editor
                    v-if="isLoaded"
                    ref="file_editor"
                    v-model="content"
                    api-key="0itmwbkqro4fsojoh3hiqjwccys6v95aj8x5k2vcgczl9vam"
                    :init="init"
                />
                <span
                    v-else
                    class="
                        m-auto
                        spinner-border spinner-border-lg
                        position-absolute
                    "
                    style="right: 0; top: 0; bottom: 0; left: 0"
                    role="status"
                    aria-hidden="true"
                />
            </div>
        </div>
        <div
            id="modal-footer"
            class="bg-white position-absolute w-100 p-3 text-right"
            style="bottom: 0"
        >
            <template v-if="action === 'save'">
                <button @click="save"
                        :disabled="isLoading"
                        type="button"
                        class="btn btn-sm btn-primary">
                        <span v-if="isLoading" class="mr-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Պահպանել
                </button>
            </template>
            <template v-if="action === 'download'">
                <button @click="downloadPDF"
                        :disabled="isLoading && isLoaded === false"
                        type="button"
                        class="btn btn-sm btn-primary">
                    <span v-if="isLoading" class="mr-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span class="mr-2">Բեռնել</span>
                    <font-awesome-icon :icon="['fas', 'download']" />
                </button>
            </template>
        </div>
    </modal>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import Editor from '@tinymce/tinymce-vue'
import download from '@/mixins/download'
import init from '@/mixins/variables'
import { asBlob } from 'html-docx-js-typescript'
import { saveAs } from 'file-saver'

export default {
    name: 'NewEditorModal',
    mixins: [download, init ],
    components: {
        VueHtml2pdf,
        editor: Editor,
        purchase_request: () => import('./firstStep/purchase_request'),
        scrapbook: () => import('./firstStep/scrapbook'),
        protocol_number_one: () => import('./firstStep/protocol_number_one'),
        contract_draft_work: () => import('./firstStep/contract_draft_work'),
        contract_draft_work_construction: () => import('./firstStep/contract_draft_work_construction'),
        contract_draft_work_construction_ru: () => import('./firstStep/contract_draft_work_construction_ru'),
        contract_draft_product: () =>import('./firstStep/contract_draft_product'),
        contract_draft_service: () =>import('./firstStep/contract_draft_service'),
        contract_draft_work_ru: () =>import('./firstStep/contract_draft_work_ru'),
        contract_draft_product_ru: () =>import('./firstStep/contract_draft_product_ru'),
        contract_draft_service_ru: () =>import('./firstStep/contract_draft_service_ru'),
        contract_offer: () => import('./firstStep/contract_offer'),
        state_revenue_committee_survey: () =>import('./secondStep/state_revenue_committee_survey'),
        announce_procedure_buy_declined: () =>import('./secondStep/announce_procedure_buy_declined'),
        announce_procedure_buy_declined_hy: () =>import('./secondStep/announce_procedure_buy_declined_hy'),
        statement_of_conflict_of_interest: () =>import('./secondStep/statement_of_conflict_of_interest'),
        notice_of_negotiations: () =>import('./secondStep/notice_of_negotiations'),
        evaluation_session: () => import('./secondStep/evaluation_session'),
        evaluation_session_ru: () =>import('./secondStep/evaluation_session_ru'),
        evaluation_session_mix: () =>import('./secondStep/evaluation_session_mix'),
        evaluation_sheet: () => import('./secondStep/evaluation_sheet'),
        evaluation_sheet_empty: () =>import('./secondStep/evaluation_sheet_empty'),
        announce_conc: () => import('./thirdStep/announce_conc'),
        announce_conc_hy: () => import('./thirdStep/announce_conc_hy'),
        announce_signed_contract: () =>import('./thirdStep/announce_signed_contract'),
        announce_signed_contract_ru: () =>import('./thirdStep/announce_signed_contract_ru'),
        procurement_procedure_protocol: () =>import('./thirdStep/procurement_procedure_protocol'),
        procurement_procedure_protocol_declined: () =>import('./thirdStep/procurement_procedure_protocol_declined'),
    },
    data() {
        return {
            isLoading: false,
            content: '',
            action: '',
            currentFile: '',
            lng: '',
            editorTitle: '',
            isLoaded: false,
            participantGroup: '',
            isEditable: false,
        }
    },
    methods: {
        handleLoadingStart(){
            this.isLoading = true
        },
        handleLoadingEnd(){
            this.isLoading = false
        },
        handleLoaded() {
            setTimeout(() => {
                this.isLoaded = true
                this.content = this.$refs.file.$el.innerHTML
            }, 1000)
        },
        handleLoading(action) {
            this.isLoading = action
        },
        handleBeforeOpen({
            params: {
                action = 'save',
                fileName,
                isEditable,
                lng = 'hy',
                editorTitle,
                participantGroup,
            },
        }) {
            this.action = action
            this.currentFile = fileName
            this.participantGroup = participantGroup
            this.isEditable = Boolean(isEditable)
            this.lng = lng
            this.editorTitle = editorTitle
        },
        save() {
            this.$refs.file.save()
        },
        async downloadPDF() {
            this.isLoading = true;
            switch (this.currentFile) {
                case 'evaluation_session':
                    this.$client
                        .put(`organize/${this.$route.params.id}`, {
                            get_evaluation_session: true,
                        })
                        .then(({ status, data }) => {
                            if (data.data) {
                                this.$store.commit(
                                    'organize/setCurrentOrganized',
                                    data.data
                                )
                            }
                        })
                    this.sendToPDFGeneration(this, this.content, this.editorTitle, () => {this.isLoading = false})
                    break
                case 'notice_of_negotiations':
                    await this.$refs.file.download()
                    break
                default:
                    this.sendToPDFGeneration(this, this.content, this.editorTitle, () => {this.isLoading = false})
                    break
            }
            // await this.$modal.hide('new-editor-modal')
        },
        async downloadDOC() {
            const newContent = await this.$refs.file.handleBeforeDownload()
            switch (this.currentFile) {
                case 'evaluation_session':
                    this.$client
                        .put(`organize/${this.$route.params.id}`, {
                            get_evaluation_session: true,
                        })
                        .then(({ status, data }) => {
                            if (data.data) {
                                this.$store.commit(
                                    'organize/setCurrentOrganized',
                                    data.data
                                )
                            }
                        })
                    break
                default:
                    break
            }
            asBlob(newContent).then((data) => {
                saveAs(data, `${this.editorTitle}.docx`)
            })
            await this.$modal.hide('new-editor-modal')
        },
        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf()
                .set(options)
                .from(pdfContent)
                .toPdf()
                .get('pdf')
                .then((pdf) => {
                    const totalPages = pdf.internal.getNumberOfPages()
                    pdf.setPage(totalPages.length - 1)
                    pdf.setFontSize(11)
                    pdf.setFont('ghea')
                    pdf.setTextColor('#0000ff')
                    pdf.text(
                        'iTender©\nwww.iTender.am',
                        pdf.internal.pageSize.getWidth() * 0.06,
                        pdf.internal.pageSize.getHeight() * 0.95
                    )
                })
                .save()
        },
    },
}
</script>
<style>
.og-bg {
    color: rgb(17, 85, 204);
}
.table-1 {
    page-break-inside: avoid;
}
.table-1 {
    border: 1px solid  black;
    border-collapse: collapse;
    margin: 20px auto;
    padding-bottom: 50px;
    text-align: center;
}
.table-1 tr th {
    border: 1px solid  black;
    border-collapse: collapse;
    font-size: 12px;
    padding: 8px 18px;
}
.table-1 tr td {
    border: 1px solid  black;
    border-collapse: collapse;
    text-align: center;
    padding: 7px 7px;
    font-size: 14px;
}
</style>
<style scoped>
.info-block p:first-child {
    display: inline !important;
}
table {
    page-break-inside: auto;
}
table {
    border: 1px solid  black !important;
    border-collapse: collapse !important;
    padding-bottom: 50px !important;
    text-align: center !important;
}
table tr th {
    border: 1px solid  black;
    border-collapse: collapse !important;
    font-size: 12px !important;
}
table tr td {
    border: 1px solid  black;
    border-collapse: collapse !important;
    text-align: center !important;
    font-size: 10px !important;
}
.full-row {
    page-break-inside: avoid;
    page-break-after: auto;
}
.info-block {
    page-break-inside: avoid;
    page-break-after: auto;
    padding-top: 20px;
    box-sizing: border-box;
}
.info-block > tr {
    margin-top: 50px;
}
/deep/ .vm--modal {
    top: 1rem !important;
    left: unset !important;
    width: 960px !important;
    height: 95% !important;
    margin: auto;
    -webkit-border-radius: 0.3rem !important;
    -moz-border-radius: 0.3rem !important;
    border-radius: 0.3rem !important;
}
</style>
